import React from "react";

const MoreShopButton = () => {
  return (
    <div fluid className="text-center mt-1">
      <button variant="dark" className="w-100 fw-semibold py-2 rounded-0">
        More Shop
      </button>
    </div>
  );
};

export default MoreShopButton;
